import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import DocumentMeta from 'react-document-meta';
import PageBanners from '../components/categoryDetailLandingPage/PageBanners';
import CategoryPageBoxes from '../components/categoryDetailLandingPage/CategoryPageBoxes';

import CategoryConversationSlider from '../components/categoryDetailLandingPage/CategoryConversationSlider';

import intros from '../misc/categoryLandingIntros';

import { loadOrganizations } from '../actions';

class CategoryDetailLP extends Component {
  constructor(props) {
    super(props);
  };

  state = {
    currentCategorySlug: this.props.params.slug
  };

  componentWillReceiveProps(nextProps) {
    this.setState({currentCategorySlug: nextProps.params.slug})
    window.scrollTo(0, 0);
  }

  componentWillMount() {
    this.props.loadOrganizations({
      category: this.props.params.slug
    });

  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }


  render() {
    // Get the current category from url category slug
    let categoryObj = {};

    for (var cat of this.props.baseState.categories) {
      if (cat.slug == this.state.currentCategorySlug) {
        categoryObj = cat;
      }
    }


    const meta = {
        title: 'WorldWideWomen | ' + String(this.props.organizations.category_seo_title || ''),
        description: String(this.props.organizations.category_seo_description || ''),
    }


    // Add specific category intro text for each category
    let introCollections = '';
    let introList = [];


    introCollections = intros[this.props.router.params.slug];

    introList = introCollections.map((item, idx) => {
      let introHeader = '';
      let introCopy = '';
      let para02 = '';
      let applyUrl = '/organizations/apply';

      introHeader = item.introHeader;

      // Map mobile and desktop copy
      let introCopyParagraphs = '';
      if (this.props.browser.greaterThan.tablet) { // Desktop copy
        introCopy = item.introCopy;

      } else {
        introCopy = item.introCopyMobile;
      }

      return <div key={idx}>
        <div className="categoryDetail-LPIntro"><h4 className="categoryDetail-LPIntro-header">Select a category and filter by location to refine your search</h4></div>

      </div>;
    });



    let conversationSlider = <CategoryConversationSlider browser={this.props.browser} slug={this.props.params.slug}  categoryName={this.props.organizations.category_name} />;

    return(
      <div className="content-wrapper">

        <DocumentMeta {...meta}></DocumentMeta>

        <div className="categoryDetailLp-outerWrapper">
          <div className="categoryDetail-inner">
            <PageBanners browser={this.props.browser} params={this.props.router.params} />


            <div className="categoryDetail-contentWrapper">


              <div className="categoryDetail-organizationsListContainerWrapper">
                <div className="categoryDetail-introWrapper">{introList}</div>

                <div className="categoryDetail-boxesWrapper">
                  <CategoryPageBoxes
                    categories={this.props.baseState.categories}
                    categoryObj ={categoryObj}
                    browser={this.props.browser}/>
                </div>

                <div className="categoryDetail-conversationSliderWrapper">{conversationSlider}</div>


              </div>
            </div>

          </div>
        </div>

      </div>
    );
  };

};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    loadOrganizations,
    push
  }
)(CategoryDetailLP);



// WEBPACK FOOTER //
// ./src/containers/CategoryDetailLP.jsx